<template>
  <div class='dialog-wrapper'>
    <el-dialog
      :visible.sync="isShowDialog" :close-on-click-modal="false"
      :title="dialogTitle" center :width="dialogWidth?dialogWidth:'1600px'" class="dialog">
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">{{dialogTitle}}</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form :label-width="labelWidth||'210px'" ref="selectData" size="mini" :model="eData">
                    <el-row>
                      <el-col :span="formItems2?12:24">
                        <el-form-item :label="x.label+'：'" v-for="(x,i) in formItems" :key="i">
                          <template v-if="['text','textarea','number','switch','select_s','date'].includes(x.type)||!x.type">{{eData[x.key]}}</template>
                          <template v-if="x.type==='select_m'">
                            <span v-for="(x2,i2) in eData[x.key]" :key="i2">{{(i2?' | ':'')+x2}}</span>
                          </template>
                          <template v-if="x.type==='upload'||x.type==='image'">
                            <template v-if="!x.limitNum||x.limitNum===1">
                              <el-image style="width: 100px; height: 100px" :src="eData[x.key]|toimg" fit="contain" :preview-src-list="[eData[x.key]]|toimgs"></el-image>
                            </template>
                            <template v-else>
                              <el-image
                                v-for="(x,i) in eData[x.key]" :key="i"
                                style="width: 100px; height: 100px" :src="x|toimg" fit="contain" :preview-src-list="eData[x.key]|toimgs"></el-image>
                            </template>
                          </template>
                          <template v-if="x.type==='video'">
                            <video v-if="eData[x.key]" controls="controls" :src="eData[x.key]|toimg" class="video">您的浏览器不支持视频播放</video>
                          </template>
                          <template v-if="x.type==='richText'">
                            <!-- <EditorBar v-model="eData[x.key]"></EditorBar> -->
                            <div v-html="eData[x.key]"></div>
                          </template>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12" v-if="formItems2">
                        <el-form-item :label="x.label+'：'" v-for="(x,i) in formItems2" :key="i">
                          <template v-if="['text','textarea','number','switch','select_s','date'].includes(x.type)||!x.type">{{eData[x.key]}}</template>
                          <template v-if="x.type==='select_m'">
                            <span v-for="(x2,i2) in eData[x.key]" :key="i2">{{(i2?' | ':'')+x2}}</span>
                          </template>
                          <template v-if="x.type==='upload'||x.type==='image'">
                            <template v-if="!x.limitNum||x.limitNum===1">
                              <el-image style="width: 100px; height: 100px" :src="eData[x.key]|toimg" fit="contain" :preview-src-list="[eData[x.key]]|toimgs"></el-image>
                            </template>
                            <template v-else>
                              <el-image
                                v-for="(x,i) in eData[x.key]" :key="i"
                                style="width: 100px; height: 100px" :src="x|toimg" fit="contain" :preview-src-list="eData[x.key]|toimgs"></el-image>
                            </template>
                          </template>
                          <template v-if="x.type==='video'">
                            <video v-if="eData[x.key]" controls="controls" :src="eData[x.key]|toimg" class="video">您的浏览器不支持视频播放</video>
                          </template>
                          <template v-if="x.type==='richText'">
                            <!-- <EditorBar v-model="eData[x.key]"></EditorBar> -->
                            <div v-html="eData[x.key]"></div>
                          </template>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 足部 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearHandler,isShowDialog=false">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 图片预览 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import mixin_upload from '@/Mixins/mixin_upload'
// 导入安装好的wangeditor
import E from 'wangeditor'
// 导入封装好的公共组件wangEditor
import EditorBar from '@/components/wangEditor'
export default {
  mixins: [mixin_upload],
  components: { EditorBar },
  props: ['dialogTitle','formItems', 'formItems2', 'dialogWidth', 'labelWidth'],
  data() {
    return {
      isShowDialog: false,
      eData: {},
    }
  },
  methods: {
    numberFormat(val) {
      // console.log(this.eData[val])
      this.eData[val] ? this.eData[val] = this.eData[val].replace(/[^\.\d]/g,'') : ''
    },
    switchChangeHandler(val) {
      // console.log(val, this.eData)
    },
    inputChangeHandler(val) {
      // console.log(val, this.eData)
    },
    selectChangeHandler(val, isWatch, key) {
      // console.log(val, this.eData)
      if (isWatch) {
        this.$emit('watchChange', {key, val})
      }
    },
    cascaderChangeHandler(val) { // 对话框中 分类选中
      // console.log(val, this.eData)
    },
    clearHandler() { // 清空对话框
      this.eData = {}
      // console.log(this.formItems)
      let items = this.formItems.filter(x => x.index)
      items.forEach(x => {
        this['fileList_' + x.index] = []
      })
      if (this.formItems2) {
        let items = this.formItems2.filter(x => x.index)
        items.forEach(x => {
          this['fileList_' + x.index] = []
        })
      }
      
    },
    viewHandler(row) {
      this.clearHandler()
      this.eData = row

      let items = this.formItems.filter(x => x.index)
      this.dateHandler(items)

      if (this.formItems2) {
        let items = this.formItems2.filter(x => x.index)
        this.dateHandler(items)
      }
      
      this.isShowDialog = true
    },
    dateHandler(items) {
      items.forEach(x => {
        // if (this.eData[x.key] && this.eData[x.key].length > 0) {
        //   if (!x.limitNum || x.limitNum === 1) {
        //     let imgId = this.eData[x.key]
        //     this['fileList_' + x.index] = [
        //       { name: imgId, url: this._img_handler(imgId), id: imgId }
        //     ]
        //   } else {
        //     this['fileList_' + x.index] = this.eData[x.key].map(x2 => {
        //       return { name: x2, url: this._img_handler(x2), id: x2 }
        //     })
        //   }
        // }
        let target = this.eData[x.key]
        console.log(target)
        switch (x.type) {
          case 'upload':
          case 'image':
          case 'video':
            if (target && target.length > 0) {
              if (!x.limitNum || x.limitNum === 1) {
                this['fileList_' + x.index] = [
                  { name: target, url: this._img_handler(target), id: target }
                ]
              } else {
                this['fileList_' + x.index] = target.map(x2 => {
                  return { name: x2, url: this._img_handler(x2), id: x2 }
                })
              }
            }
            break;
          case 'document':
            if (target && (target.fileId || target.length > 0)) {
              if (!x.limitNum || x.limitNum === 1) {
                this['fileList_' + x.index] = [
                  { name: target.fileName, url: this._img_handler(target.fileId), id: target.fileId }
                ]
              } else {
                this['fileList_' + x.index] = target.map(x2 => {
                  return { name: x2.fileName, url: this._img_handler(x2.fileId), id: x2.fileId }
                })
              }
            }
            break;
        }
      })
    },
  },
}
</script>

<style lang='scss' scoped>
// @import '@/assets/css/dialog.scss';
// /deep/ .el-dialog {margin-top:80px !important;border-radius: 20px;} // 取消对话框与顶部默认距离

// /deep/ .el-upload--picture-card,
// /deep/ .el-upload-list__item {width:90px;height:90px;position:relative;transition:none !important;} // 图片盒子大小
// /deep/ .el-icon-plus {width:28px;height:28px; position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;} // 图片加号位置
// /deep/ .disabled .el-upload--picture-card {display:none} // 图片超出数量限制 隐藏上传按钮

// /deep/ .el-form-item__label,
// /deep/ .el-cascader__search-input,
// /deep/ .el-radio__label {font-size: 12px;}

// /deep/ .el-form-item {margin-bottom:10px;} // 设置每行间距


// /deep/ .el-input--mini .el-input__icon {line-height: 36px;} // 选择器 icon位置


// /deep/.el-select__tags{overflow: auto;}
.video{width: 400px;max-height: 240px;}

</style>